"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _humanTime2 = require("../humanTime");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

var empty = _react.default.createElement("span", {
  className: "empty"
}, "\u2014");

var Time = function Time(_ref) {
  var datetime = _ref.datetime,
      withSeconds = _ref.withSeconds;

  if (!datetime) {
    return empty;
  }

  var _humanTime = (0, _humanTime2.humanTime)(datetime, withSeconds),
      time = _humanTime.time;

  return time || empty;
};

Time.propTypes = {
  datetime: _propTypes.default.oneOfType([_propTypes.default.string, _momentPropType.default, _propTypes.default.instanceOf(Date)]).isRequired,
  withSeconds: _propTypes.default.bool
};
var _default = Time;
exports.default = _default;